
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AffectedProjectOnUmbrellaChangeResource,
  UmbrellaCompanySearchResults,
  UmbrellaFreelancerRequestResources,
  UmbrellaValidationRequest,
} from '../models';
import {
    AffectedProjectOnUmbrellaChangeResourceFromJSON,
    AffectedProjectOnUmbrellaChangeResourceToJSON,
    UmbrellaCompanySearchResultsFromJSON,
    UmbrellaCompanySearchResultsToJSON,
    UmbrellaFreelancerRequestResourcesFromJSON,
    UmbrellaFreelancerRequestResourcesToJSON,
    UmbrellaValidationRequestFromJSON,
    UmbrellaValidationRequestToJSON,
} from '../models';

export interface AcceptRequestRequest {
    companyId: string;
    umbrellaValidationRequest: UmbrellaValidationRequest;
}

export interface CanRemoveFreelancerRequest {
    companyId: string;
    freelancerCompanyId: string;
}

export interface GetAffectedProjectsOnUmbrellaChangeRequest {
    companyId: string;
}

export interface GetAllFreelancerRequestRequest {
    companyId: string;
}

export interface RefuseRequestRequest {
    companyId: string;
    umbrellaValidationRequest: UmbrellaValidationRequest;
}

export interface RemoveFreelancerRequest {
    companyId: string;
    freelancerCompanyId: string;
}

export interface SearchUmbrellaCompaniesRequest {
    name: string;
}

/**
 * 
 */
export class UmbrellaApi extends runtime.BaseAPI {

    /**
          */
    async acceptRequestRaw(requestParameters: AcceptRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling acceptRequest().'
            );
        }

        if (requestParameters['umbrellaValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'umbrellaValidationRequest',
                'Required parameter "umbrellaValidationRequest" was null or undefined when calling acceptRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/{companyId}/freelancer-requests/accept`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UmbrellaValidationRequestToJSON(requestParameters['umbrellaValidationRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async acceptRequest(requestParameters: AcceptRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptRequestRaw(requestParameters, initOverrides);
    }

    /**
          */
    async canRemoveFreelancerRaw(requestParameters: CanRemoveFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling canRemoveFreelancer().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling canRemoveFreelancer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/compliance/api/umbrella/{companyId}/my-freelancers/can-remove`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async canRemoveFreelancer(requestParameters: CanRemoveFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.canRemoveFreelancerRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getAffectedProjectsOnUmbrellaChangeRaw(requestParameters: GetAffectedProjectsOnUmbrellaChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AffectedProjectOnUmbrellaChangeResource>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getAffectedProjectsOnUmbrellaChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<AffectedProjectOnUmbrellaChangeResource>>({
            path: `/compliance/api/company/{companyId}/affected-projects-on-umbrella-change`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(AffectedProjectOnUmbrellaChangeResourceFromJSON);
        return response;
    }

    /**
          */
    async getAffectedProjectsOnUmbrellaChange(requestParameters: GetAffectedProjectsOnUmbrellaChangeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AffectedProjectOnUmbrellaChangeResource>> {
        const response = await this.getAffectedProjectsOnUmbrellaChangeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getAllFreelancerRequestRaw(requestParameters: GetAllFreelancerRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UmbrellaFreelancerRequestResources>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getAllFreelancerRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UmbrellaFreelancerRequestResources>({
            path: `/compliance/api/umbrella/{companyId}/freelancer-requests`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UmbrellaFreelancerRequestResourcesFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getAllFreelancerRequest(requestParameters: GetAllFreelancerRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UmbrellaFreelancerRequestResources> {
        const response = await this.getAllFreelancerRequestRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async refuseRequestRaw(requestParameters: RefuseRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling refuseRequest().'
            );
        }

        if (requestParameters['umbrellaValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'umbrellaValidationRequest',
                'Required parameter "umbrellaValidationRequest" was null or undefined when calling refuseRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/{companyId}/freelancer-requests/refuse`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UmbrellaValidationRequestToJSON(requestParameters['umbrellaValidationRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async refuseRequest(requestParameters: RefuseRequestRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.refuseRequestRaw(requestParameters, initOverrides);
    }

    /**
          */
    async removeFreelancerRaw(requestParameters: RemoveFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling removeFreelancer().'
            );
        }

        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling removeFreelancer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['freelancerCompanyId'] != null) {
            queryParameters['freelancerCompanyId'] = requestParameters['freelancerCompanyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/{companyId}/my-freelancers/remove`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async removeFreelancer(requestParameters: RemoveFreelancerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFreelancerRaw(requestParameters, initOverrides);
    }

    /**
     * Search umbrella companies by name
          */
    async searchUmbrellaCompaniesRaw(requestParameters: SearchUmbrellaCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UmbrellaCompanySearchResults>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling searchUmbrellaCompanies().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UmbrellaCompanySearchResults>({
            path: `/compliance/api/umbrella/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UmbrellaCompanySearchResultsFromJSON(response._data); }
        return response;
    }

    /**
     * Search umbrella companies by name
          */
    async searchUmbrellaCompanies(requestParameters: SearchUmbrellaCompaniesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UmbrellaCompanySearchResults> {
        const response = await this.searchUmbrellaCompaniesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
